import { toast } from 'react-toastify';
import { errorMessages } from '../constants/errorMesages';

let isAddNewToast = false;

export const ShowNotification = (
  message?: string,
  status: 'success' | 'info' | 'error' | 'warning' = 'info',
): MethodDecorator => (_target, _propertyKey, descriptor: PropertyDescriptor) => {
  const originalMethod = descriptor.value;

  descriptor.value = async (...args: unknown[]) => {
    let result;

    try {
      result = await originalMethod.apply(this, args);
      message && toast[status](message);
    } catch (error) {

      if (!isAddNewToast) {
        toast.error(setArgsToError(error));
        isAddNewToast = true;
      }
      else {
        setTimeout(() => isAddNewToast = false, 3500);
      }

      return Promise.reject(error);
    }
    return result;
  };
};

const setArgsToError = (error: any) => {
  let errorMsg = errorMessages.get(error.response?.data?.code) || 'Что-то пошло не так';
  const args: string[] = error.response?.data?.args || [];
  const replacer = () => args.shift();
  
  while (errorMsg.includes('~') && args.length !== 0) {
    errorMsg = errorMsg.replace('~', replacer);
  }

  return errorMsg;
}